import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { supabase } from '../lib/supabase';

export function useSuperAdmin() {
    const { user } = useAuth();
    const [isSuperAdmin, setIsSuperAdmin] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function checkSuperAdmin() {
            if (!user) {
                setIsSuperAdmin(false);
                setLoading(false);
                return;
            }

            try {
                const { data, error } = await supabase
                    .from('business_profiles')
                    .select('is_super_admin')
                    .eq('id', user.id)
                    .single();

                if (error) {
                    console.error('Error checking super admin status:', error);
                    setIsSuperAdmin(false);
                } else {
                    setIsSuperAdmin(data?.is_super_admin || false);
                }
            } catch (err) {
                console.error('Error in checkSuperAdmin:', err);
                setIsSuperAdmin(false);
            } finally {
                setLoading(false);
            }
        }

        checkSuperAdmin();
    }, [user]);

    return { isSuperAdmin, loading };
}
